<script lang="ts" setup>
import { Header } from '@brighterly/lib-lumee-ui'

import { useScreenWidth } from '@shared/lib/browser'
import { useAppLogoDomain } from '@shared/ui/logos'

import { useHeaderLogo } from './header-logo.hook'
import HeaderMenu from './HeaderMenu.vue'
import KidSwitcher from './KidSwitcher.vue'

defineOptions({
  name: 'AppHeader',
})

const { logoBrand } = useAppLogoDomain()

const {
  homeUrl,
  trackLogoClick,
} = useHeaderLogo()

const { isMobile } = useScreenWidth()
</script>

<template>
  <div class="app-header">
    <Header
      :brand="logoBrand"
      :logo-href="homeUrl"
      @logo-click="trackLogoClick"
    >
      <template
        v-if="!isMobile"
        #navSlot
      >
        <HeaderMenu layout="horizontal" />
      </template>
      <template #account>
        <KidSwitcher />
      </template>
    </Header>
  </div>
</template>

<style scoped lang="scss" src="./AppHeader.scss" />
